import LightBox from '../../../../components/LightBox'
import ChooseReportComponent from './ChooseReportComponent'
import ChooseReportHeader from './ChooseReportHeader'
import ChooseReportFooter from './ChooseReportFooter'


export default class DescriptionLightbox extends LightBox {
    constructor({
        reportUrls = {},
        reportNameKeys = {},
    }) {
        super()

        this.params = {
            reportUrls,
            reportNameKeys,
        }

        this.close_tab_confirmation_message_key = "project.add.js.close_tab_confirmation"
        this.exist_invalid_fields_message_key = "project.common.errormsg"
        this.cancel_confirmation_message_key = "project.add.js.cancel_confirmation"

        this.cancelCallback = this.hide
    }

    init() {
        const header = new ChooseReportHeader({})
        const footer = new ChooseReportFooter({})
        const content = new ChooseReportComponent({
            reportUrls: this.params.reportUrls,
            reportNameKeys: this.params.reportNameKeys,
        })
        super.init(
            {
                id: 'createReportLightBox', // do not delete
                header,
                content,
                footer,
                classNames: 'reportDescriptionLightbox lightboxWithWhiteContent',
                correctionOffset: -60 /* offset of the innerContent in the popup content used when scrolling to section with error*/
            })

        return this
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/DescriptionLightbox.js